import React from "react";

import CodeBlock from "../../../../docs/components/CodeBlock";
import type { Language } from "../../../../docs/components/CodeBlock";

// A docs code block. The copy button (and all copy behavior) lives in the shared
// CodeBlock; this wrapper just accepts a loosely-typed `language` string from MDX
// and narrows it to the CodeBlock's Language union.
function CopyCodeBlock({
  children,
  code,
  style,
  language,
  hideCopy,
}: {
  language?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  code?: string;
  hideCopy?: boolean;
}) {
  return (
    <CodeBlock
      style={style}
      code={code}
      hideCopy={hideCopy}
      language={language as Language | undefined}
    >
      {children}
    </CodeBlock>
  );
}

export default CopyCodeBlock;
